import React from 'react'
import DocsWebinarCard from './DocsWebinarCard'
import EmptySection from '../../../common/EmptySection'
import { Webinar } from '../../api/Types'

interface Props {
  readonly webinars: ReadonlyArray<Webinar>
  readonly isBot: boolean
}

const DocsWebinars: React.FunctionComponent<Props> = ({ webinars, isBot }) => {
  const displayWebinars = () => {
    if (webinars.length > 0) {
      return webinars.map(webinar => {
        return <DocsWebinarCard key={webinar.id} webinar={webinar} isBot={isBot}/>
      })
    } else {
      return <EmptySection message='We couldn&#39;t find any webinars!' />
    }
  }
  return <div className='docs-webinars-list'>{displayWebinars()}</div>
}

export default DocsWebinars
